// CommunityTabs.tsx — Discover / Following / Invitations directory tabs.
import { Tabs } from '@/ui';
import { DIR_TABS, type DirTab } from './meta';

export interface CommunityTabsProps {
  active: DirTab;
  onChange: (id: DirTab) => void;
  inviteCount: number;
}

export function CommunityTabs({ active, onChange, inviteCount }: CommunityTabsProps) {
  const items = DIR_TABS.map((t) => ({
    value: t.id,
    label: t.id === 'invitations' && inviteCount > 0 ? `${t.label} (${inviteCount})` : t.label,
  }));
  return <Tabs items={items} value={active} onChange={(v) => onChange(v as DirTab)} />;
}
